import React, { Component, useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import PortfolioService from '../../services/portfolio.service'
import {
  getCurrentAccDetailsSelector,
  getMenuListSelector,
} from '../../store/selectors/app.selector'
import LayoutWithAccountCard from '../Layout/layout-account-card'
import StatementIcon from 'custom/assets/accounts/Statement.svg'
import DetailsIcon from 'custom/assets/accounts/Details.svg'
import { useHistory } from 'react-router-dom'
import './statement.css'
import { NeoLoader } from '../../components/FormComponents'
import moment from 'moment'
import UserIcon from 'custom/assets/common-icons/User.svg'
import SpendIcon from 'custom/assets/common-icons/Spend.svg'
import CreditIcon from 'custom/assets/common-icons/Spend.svg'
import NumberFormat from 'react-number-format'
import { useTranslation } from 'react-i18next'
import { STATEMENT_KEYS } from '../../utils/translation-constants'

export default function Statement() {
  const history = useHistory()
  const [statementList, setStatementList] = useState([])
  const accountDetails = useSelector(getCurrentAccDetailsSelector) || {}
  const [loader, setLoader] = useState(false)
  const [expanded, setExpanded] = useState(null)
  const { t } = useTranslation()
  const menuConfig = useSelector(getMenuListSelector)['STATEMENT'] || {}

  useEffect(() => {
    topTenTxn()
  }, [])

  const topTenTxn = useCallback(async () => {
    try {
      setLoader(true)
      const response = await PortfolioService.topTenTxn(accountDetails)
      if (response.status === 200) {
        setStatementList(response.data['miniStatement'])
        setLoader(false)
      }
    } catch (err) {
      setLoader(false)
    }
  }, [accountDetails])

  return (
    <LayoutWithAccountCard breadCumKey='STATEMENTS'>
      <div className='row'>
        <div className='col-7 d-flex'>
          <div>
            <img src={StatementIcon} alt='statement icon' />
          </div>
          <div className='title-spacing'>
            <span className='font-weight-bold'>{t(STATEMENT_KEYS.HEADER)}</span>
            <span className='header-title-section'>
              <p>{t(STATEMENT_KEYS.DESCRIPTION)}</p>
            </span>
          </div>
        </div>
        {menuConfig['DETAILED_STATEMENT'] && (
          <div className='col-5 text-right'>
            <button
              tabIndex={'1'}
              type='button'
              className='btn p-2 detailed-statement-btn'
              onClick={() => history.push('/detailed-statement')}>
              <img src={DetailsIcon} alt='' className='mr-2' height={23} width={20} />
              <span className='font-weight-600'>{t(STATEMENT_KEYS.DETAILED_STATEMENT)}</span>
            </button>
          </div>
        )}
      </div>

      {loader && <NeoLoader />}

      {!loader && statementList.length === 0 && (
        <div className='text-center'>{t(STATEMENT_KEYS.NO_TRANSACTION)}</div>
      )}

      {statementList.map((stmnt, i) => (
        <div key={i} className='statement-item'>
          <div
            className='d-flex justify-content-between font-weight-600'
            onClick={() => (expanded == i ? setExpanded(null) : setExpanded(i))}>
            <div className='d-flex'>
              <div className='mr-3'>
                <img src={UserIcon} alt='user icon' className='user-icon p-2' />
              </div>
              <div>
                <div className='statement-desc'>{stmnt.txnTypeDes}</div>
                <div className='statement-date-time'>
                  {stmnt['date'] !== null ? stmnt['date'] : '-'}
                </div>
              </div>
            </div>
            <div className='text-right'>
              <div>
                <span className='statement-currency mr-1'>{stmnt.txnCurrency}</span>
                <span className='statement-amount'>
                  <NumberFormat
                    value={stmnt.amount}
                    displayType={'text'}
                    thousandSeparator={true}
                    prefix={''}
                    fixedDecimalScale={true}
                    decimalScale={2}
                    allowEmptyFormatting
                  />
                </span>
                {/* {stmnt.debitOrCredit == 'Debit' ? (
                  <img src={SpendIcon} alt='' />
                ) : (
                  <img src={CreditIcon} alt='' style={{ transform: 'rotateZ(180deg)' }} />
                )} */}
              </div>
              <div className='statement-date-time'>
                {/* {new Date().getHours() + ':' + new Date().getMinutes()} */}
              </div>
            </div>
          </div>
          {expanded == i && (
            <div className='ml-2 mt-3'>
              <div className='row my-2'>
                <div className='col-4'>
                  <div className='statement-expanded-label font-weight-500'>
                    {t(STATEMENT_KEYS.REF_NO)}
                  </div>
                  <div className='statement-expanded-value font-weight-bold'>
                    {stmnt?.refNo || '---'}
                  </div>
                </div>
                <div className='col-4'>
                  <div className='statement-expanded-label font-weight-500'>
                    {t(STATEMENT_KEYS.CURRENCY)}
                  </div>
                  <div className='statement-expanded-value font-weight-bold'>
                    {stmnt.txnCurrency}
                  </div>
                </div>
                <div className='col-4'>
                  <div className='statement-expanded-label font-weight-500'>
                    {t(STATEMENT_KEYS.AMOUNT)}
                  </div>
                  <div className='statement-expanded-value font-weight-bold'>
                    <NumberFormat
                      value={stmnt.amount}
                      displayType={'text'}
                      thousandSeparator={true}
                      prefix={''}
                      fixedDecimalScale={true}
                      decimalScale={2}
                      allowEmptyFormatting
                    />
                  </div>
                </div>
              </div>
              <div className='row my-2'>
                <div className='col-4'>
                  <div className='statement-expanded-label font-weight-500'>
                    {t(STATEMENT_KEYS.TXN_TYPE_DESC)}
                  </div>
                  <div className='statement-expanded-value font-weight-bold'>
                    {stmnt.txnTypeDes}
                  </div>
                </div>
                <div className='col-4'>
                  <div className='statement-expanded-label font-weight-500'>
                    {t(STATEMENT_KEYS.TRANSACTION_DATE)}
                  </div>
                  <div className='statement-expanded-value font-weight-bold'>
                    {stmnt['date'] !== null ? stmnt['date'] : '-'}
                  </div>
                </div>
                <div className='col-4'>
                  <div className='statement-expanded-label font-weight-500'>
                    {t(STATEMENT_KEYS.DEBIT_CREDIT)}
                  </div>
                  <div className='statement-expanded-value font-weight-bold'>
                    {stmnt.debitOrCredit}
                  </div>
                </div>
              </div>
              <div className='row my-2'>
                <div className='col-12'>
                  <div className='statement-expanded-label font-weight-500'>
                    {t(STATEMENT_KEYS.REMARKS)}
                  </div>
                  <div className='statement-expanded-value font-weight-bold'>
                    {stmnt.narration || '---'}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      ))}
    </LayoutWithAccountCard>
  )
}
